import { render, staticRenderFns } from "./ScrollerMenu.vue?vue&type=template&id=6a04b13e&scoped=true"
import script from "./ScrollerMenu.vue?vue&type=script&lang=js"
export * from "./ScrollerMenu.vue?vue&type=script&lang=js"
import style0 from "./ScrollerMenu.vue?vue&type=style&index=0&id=6a04b13e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a04b13e",
  null
  
)

export default component.exports